import script from "./EsgDetailPage.vue?vue&type=script&setup=true&lang=js"
export * from "./EsgDetailPage.vue?vue&type=script&setup=true&lang=js"

import "./EsgDetailPage.vue?vue&type=style&index=0&id=3de5d658&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3de5d658"]])

export default __exports__